import { ReferenceLocation } from '@/types';

export const buildLocationQuery = (location: ReferenceLocation | null) => ({
  page: 0,
  town: null,
  zip: null,
  locType: location?.type ?? null,
  locCode: location?.code ?? null,
  locName: location?.name ?? null,
  locPostcode: location?.postcode ?? null,
});
